import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { map, Observable } from 'rxjs';

import { Option, Role } from '@hmax-order/shared/types';

import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class UserRolesResolver implements Resolve<Role[]> {
  private _userService = inject(UserService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Role[]> {
    return this._userService.getRoles().pipe(
      map((roles: Role[]) => {
        return roles.map((role) => {
          return {
            name: role?.name,
            value: role,
          } as Option;
        });
      }),
    );
  }
}
